import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class grittiZeroCanoneEle {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 205,
        Id_Foritore: 2,
        Id_comodity: 1,
        TipoContratto:1,
        NomeOfferta: "ZERO CANONE",
        LinkFoto: "./assets/images/offerte-gritti/zerocanone-luce.jpg",
        LinkFotoLarge: "./assets/images/offerte-gritti/zerocanone-luce.jpg",
        LinkFotoMid: "./assets/images/offerte-gritti/zerocanone-luce.jpg",
        LinkFotoSm: "./assets/images/offerte-gritti/zerocanone-luce.jpg",
        LinkFotoCarousel: "./assets/images/offerte-gritti/zerocanone-luce.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "SCONTO CANONE TV -45€ €/anno",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "VANTAGGI ASSICURATI",
            DescrizioneSezione: "",
            lstPunti: ["0 COSTI DI ATTIVAZIONE", "24 MESI PREZZO FISSO","0 DEPOSITO CAUZIONALE","AREA RISERVATA WEB","ASSISTENZA CLIENTI","da lunedì a domenica 0-24","fornitura di energia elettrica proveniente da FONTI RINNOVABILE SENZA ALCUN COSTO AGGIUNTIVO "]
          },
        ],
        PrezzoEle: 0.086,
        PrezzoGas: 0,
       
        TitoloPlus: "VANTAGGI ASSICURATI",
        Plus: ["0 COSTI DI ATTIVAZIONE", "24 MESI PREZZO FISSO","0 DEPOSITO CAUZIONALE","AREA RISERVATA WEB","ASSISTENZA CLIENTI",]

        , schedaconfrontabilitaele: {
          tabellaConfrontabilita: [
            { consumoannuo: 1500, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 353.14 },
            { consumoannuo: 2200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 471.47 },
            { consumoannuo: 2700, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 564.35 },
            { consumoannuo: 3200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 657.23 },
            { consumoannuo: 1500, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 353.14 },
            { consumoannuo: 2200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 471.47 },
            { consumoannuo: 2700, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 564.35 },
            { consumoannuo: 3200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 657.23 },
            { consumoannuo: 1500, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 353.14 },
            { consumoannuo: 2200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 471.47 },
            { consumoannuo: 2700, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 564.35 },
            { consumoannuo: 3200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 657.23 },
  
            
            { consumoannuo: 900, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 398.10 },
            { consumoannuo: 4000, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 922.05 },
            { consumoannuo: 900, tipoprofilo:2, Residente: 2, potenza: 3, importo: 398.10 },
            { consumoannuo: 4000, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 922.05 },
            { consumoannuo: 900, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 398.10 },
            { consumoannuo: 4000, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 922.05 },
  
            { consumoannuo: 3500, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 744.90 },
            { consumoannuo: 3500, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 744.90 },
            { consumoannuo: 3500, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 744.90 },
  
            { consumoannuo: 3500, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 744.90 },
            { consumoannuo: 3500, tipoprofilo: 2, Residente: 2, potenza: 4.5, importo: 744.90 },
            { consumoannuo: 3500, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 744.90 }
  
          ]
        }
        ,schedaconfrontabilitagas:
        {
          tabellaConfrontabilita:[]
        }
        ,lstModalitaPagamento :["1","2"]
        ,scontoRid:0 
        ,TipoSoglieEle: Soglie.SogliaMomoEleNew()
        ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/grittiZeroCanoneEle.ts